import React from 'react';
import {render} from 'react-dom';
//  import { Route, Switch, Link } from 'react-router-dom'
import MainMenu from './components/menu.js'
import configureStore from './store/configureStore';
import {Provider}from 'react-redux';
 import registerServiceWorker from './registerServiceWorker';

 const store = configureStore();
render(
    <Provider store = {store}>
        <div>
            <MainMenu link1 = '/#' link2  = '/dashboard' link3 = '/about' link4 = '/account' link5 = '/network/settings' link6 = '/login'/>
        </div>
    </Provider>,

    document.getElementById('root')

)

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js